<template>
  <transition name="modal-fade">
    <div v-if="visible" class="login-modal-overlay" @click.self="handleClose">
      <div class="login-modal-container">
        <button class="modal-close-btn" @click="handleClose" :aria-label="$t('common.close')">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        <div class="login-modal-body">
          <!-- 左侧：登入 -->
          <div class="login-panel">
            <h2 class="login-title">{{ $t('login_modal.title') }}</h2>
            <form class="login-form" @submit.prevent="handleLogin">
              <input
                v-model="form.email"
                type="text"
                class="form-input"
                :placeholder="$t('login_modal.email_placeholder')"
              />
              <div class="password-field">
                <input
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-input"
                  :placeholder="$t('login_modal.password_placeholder')"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  :aria-label="showPassword ? $t('login_modal.hide_password') : $t('login_modal.show_password')"
                  @click="toggleShowPassword"
                >
                  <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </button>
              </div>
              <div class="forgot-row">
                <a href="#" class="forgot-link" @click.prevent="handleForgotPassword">{{ $t('login_modal.forgot_password') }}</a>
              </div>
              <button type="submit" class="btn-login">{{ $t('login_modal.login_btn') }}</button>
            </form>
          </div>

          <!-- 右侧：TIME Club -->
          <div class="club-panel">
            <div class="club-content">
              <div class="time-club-logo">
                <img :src="timeClubLogo" alt="TIME Club" />
              </div>
              <div class="benefits-row">
                <div v-for="(item, index) in benefits" :key="index" class="benefit-item">
                  <div class="benefit-icon">
                    <img :src="item.image" :alt="item.text" />
                  </div>
                  <span class="benefit-text">{{ $t(`login_modal.benefits.${item.key}`) }}</span>
                </div>
              </div>
            </div>
            <button class="btn-register" @click="handleGoRegister">{{ $t('login_modal.register_btn') }}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
import { CLUB_BENEFITS, TIME_CLUB_LOGO } from '@/constants/benefits'

export default {
  name: 'LoginModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      showPassword: false,
      timeClubLogo: TIME_CLUB_LOGO,
      benefits: CLUB_BENEFITS
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        this.resetBodyOverflow()
      }
    }
  },
  methods: {
    ...mapActions(['login', 'closeLoginModal', 'openRegisterModal', 'openForgotPasswordModal', 'showToast']),
    handleClose() {
      this.closeLoginModal()
      this.$emit('close')
    },
    async handleLogin() {
      if (!this.form.email || !this.form.password) {
        this.showToast({ message: this.$t('toast.email_password_required'), type: 'warning' })
        return
      }
      const ok = await this.login({ email: this.form.email, password: this.form.password })
      if (ok) {
        this.form = { email: '', password: '' }
      }
    },
    handleGoRegister() {
      this.closeLoginModal()
      this.openRegisterModal()
    },
    handleForgotPassword() {
      this.closeLoginModal()
      this.openForgotPasswordModal()
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword
    },
    resetBodyOverflow() {
      const { cartModalVisible, registerModalVisible, forgotPasswordModalVisible } = this.$store.state
      if (!cartModalVisible && !registerModalVisible && !forgotPasswordModalVisible) {
        document.body.style.overflow = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
}

.login-modal-container {
  background: #fff;
  width: 840px;
  max-width: 94vw;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
}

.modal-close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  color: #bbb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: color 0.3s;

  &:hover {
    color: #666;
  }
}

.login-modal-body {
  display: flex;
  min-height: 400px;
}

/* 左侧登入 */
.login-panel {
  flex: 1;
  padding: 52px 50px 44px;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.login-title {
  text-align: center;
  font-size: 22px;
  color: #555;
  font-weight: 400;
  margin: 0 0 36px;
}

.login-form {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-input {
  width: 100%;
  padding: 15px 22px;
  border: 1px solid #e8e8e8;
  border-radius: 30px;
  background: #f7f7f7;
  font-size: 14px;
  color: #333;
  outline: none;
  margin-bottom: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s, background 0.3s;

  &::placeholder {
    color: #bbb;
  }

  &:focus {
    border-color: #b89766;
    background: #fff;
  }
}

.password-field {
  position: relative;
  margin-bottom: 14px;

  .form-input {
    margin-bottom: 0;
    padding-right: 48px;
  }
}

.password-toggle-btn {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  color: #bbb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: color 0.3s;

  &:hover {
    color: #b89766;
  }
}

.forgot-row {
  text-align: right;
  margin-bottom: auto;
  padding-bottom: 28px;
}

.forgot-link {
  font-size: 12px;
  color: #999;
  text-decoration: none;

  &:hover {
    color: #b89766;
  }
}

.btn-login {
  width: 100%;
  padding: 15px;
  background: #b89766;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
  letter-spacing: 1px;
  margin-top: auto;

  &:hover {
    background: #a68658;
  }
}

/* 右侧 TIME Club */
.club-panel {
  flex: 1;
  padding: 52px 44px 44px;
  background: #f3f3f3;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.club-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.time-club-logo {
  margin-bottom: 38px;

  img {
    height: 40px;
    width: auto;
    object-fit: contain;
  }
}

.benefits-row {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
}

.benefit-item {
  flex: 1;
  max-width: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.benefit-icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 48px;
    max-height: 48px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
}

.benefit-text {
  font-size: 10px;
  color: #999;
  line-height: 1.4;
  text-align: center;
}

.btn-register {
  width: 100%;
  padding: 15px;
  background: #3a3a3a;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
  letter-spacing: 1px;
  margin-top: auto;

  &:hover {
    background: #2a2a2a;
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-active .login-modal-container,
.modal-fade-leave-active .login-modal-container {
  transition: transform 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter .login-modal-container,
.modal-fade-leave-to .login-modal-container {
  transform: scale(0.96);
}

@media (max-width: 680px) {
  .login-modal-body {
    flex-direction: column;
    min-height: auto;
  }

  .login-panel {
    padding: 40px 28px 28px;
  }

  .club-panel {
    padding: 32px 28px 28px;
    border-top: 1px solid #e8e8e8;
  }

  .forgot-row {
    margin-bottom: 20px;
    padding-bottom: 0;
  }

  .btn-login {
    margin-top: 0;
  }

  .benefits-row {
    flex-wrap: wrap;
    gap: 12px;
  }

  .benefit-item {
    flex: 0 0 40%;
    max-width: none;
  }
}
</style>
